export default "./images/survio-3Ty0y-assets-langs.svg";